import { request } from './helpers/request'

export default () =>
  request({
    url: '/users/mfa/totp/register',
    method: 'GET',
  }).then((response) => {
    if (response.status === 200) {
      return Promise.resolve(response.data)
    }
    return Promise.reject(new Error(response.data.code))
  })
